export default "data:text/vtt;charset=utf-8;base64,V0VCVlRUCktpbmQ6IGNhcHRpb25zCgowMDowMDowMC4wMDAgLS0+IDA5OjAwOjAwLjAwMArimaoK"